/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const LockBadge16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M8 0a8 8 0 110 16A8 8 0 018 0zm0 1a7 7 0 100 14A7 7 0 008 1zm2.002 6A2 2 0 0112 8.998v2.004A1.993 1.993 0 0110.002 13H5.998A2 2 0 014 11.002V8.998C4 7.894 4.887 7 5.998 7h4.004zm0 1H5.998A.993.993 0 005 8.998v2.004a1 1 0 00.998.998h4.004a.993.993 0 00.998-.998V8.998A1 1 0 0010.002 8zM8.5 9a.5.5 0 010 1h-1a.5.5 0 010-1h1zm.49-5.5c.834 0 1.51.668 1.51 1.5v1a.5.5 0 11-1 0V5c0-.277-.225-.5-.51-.5H7.01c-.288 0-.51.22-.51.5v1a.5.5 0 01-1 0V5c0-.832.67-1.5 1.51-1.5z"
        />
    </AccessibleSVG>
);

export default LockBadge16;
